import { Turbo } from "@hotwired/turbo-rails"
import "../turbo_config"

// Turbo Drive on, against the generator's default: the Component Pack turns it back on.
// Opt out per link with data-turbo="false".
Turbo.session.drive = true

// Stimulus
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
const controllers = import.meta.glob("../controllers/**/*_controller.{js,tsx}", { eager: true })
registerControllers(application, controllers)
